import { useEffect, useState } from "react";
import type { Site } from "./types";

let cache: Site[] | null = null;
const subscribers = new Set<(s: Site[]) => void>();

async function load() {
  if (cache) return cache;
  const resp = await fetch("/eu-sites.json");
  const data: Site[] = await resp.json();
  cache = data;
  subscribers.forEach((cb) => cb(data));
  return data;
}

export function useSites(): Site[] {
  const [sites, setSites] = useState<Site[]>(cache ?? []);
  useEffect(() => {
    if (cache) {
      setSites(cache);
    } else {
      load().then(setSites);
    }
    const cb = (s: Site[]) => setSites(s);
    subscribers.add(cb);
    return () => {
      subscribers.delete(cb);
    };
  }, []);
  return sites;
}
